import { useEffect, useRef, useState } from 'react';
import SmsServiceEdit from './SmsServiceEdit';
import WebUniversal, { WebUniversalProps } from '../../system/WebUniversal';
import { columnsheadId } from '../../universal/columnshead';
import { Button, Space } from 'antd';
import SendMessage from './SendMessage';
import fetchApi from '../../../utilsTsx/components/system/fetchApi';
import CustomSelect from '../../../utilsTsx/components/hooks/CustomSelect';

/**
 * 组件 
 * @param props 
 * @returns 
 */
const SmsService = (props: any) => {
    const apiId = 'smsService';
    /** 可使用WebUniversal(父)组件函数 */
    const ref = useRef<any>(undefined);
    const [modalSendMessageVisible, setModalSendMessageVisible] = useState<boolean>(false);
    const [modalSendMessageData, setModalSendMessageData] = useState<any>();
    const [smsProviderData, setSmsProviderData] = useState<any>();
    const [fetchData, setFetchData] = useState<any>();
    const [sendPageData, setSendPageData] = useState<any>();

    useEffect(() => {
        let urlService;
        if (ref.current) {
            urlService = ref.current.defaultService;
            setFetchData(() => ref.current.fetchData);
            setSendPageData(ref.current.sendPageData);
        }
        fetchApi.GET(urlService,
            {
                query: {
                    apiId: 'generalData',
                    apiVariable: 'smsProvider',
                    apiExtend: 'showLists'
                }
            }).then(res => {
                if (res.success) {
                    const { smsProvider } = res.data;
                    setSmsProviderData([{ id: 'ALLITEM', name: '所有服务商' }, ...smsProvider]);
                }
            })
    }, []);

    /** 表头内容 */
    const columnsHead = [
        {
            title: '名称',
            dataIndex: 'serviceName',
        },
        {
            title: '服务商',
            dataIndex: 'smsProvider',
            render: (val: any) => val?.name
        },
        {
            title: '',
            dataIndex: 'id',
            render: (val: string, record: any) => (<Button type='primary' onClick={
                () => {
                    setModalSendMessageData({
                        smsServiceId: val,
                        serviceName: record?.serviceName,
                        templateContent: record?.smsProviderId === 2 ? record?.templateContent : undefined
                    });
                    setModalSendMessageVisible(true);
                }
            }>发送短信</Button>)
        }
    ];

    /**
     * 表头
     */
    const columns = columnsheadId
        .concat(columnsHead as []);

    /**
     * 扩展Props
     */
    let extendProps: WebUniversalProps = {
        ...props,
        titleName: '短信服务',
        apiId,
        columns,
        serviceId: 'business',
        editOptions: {
            Editor: SmsServiceEdit
        }
    };

    return (
        <>
            <Space>
                <CustomSelect
                    apiId={apiId}
                    sendKeyId='smsProviderId'
                    getListData={smsProviderData}
                    sendPageData={sendPageData}
                    setSendPageData={setSendPageData}
                    fetchData={fetchData}
                />
            </Space>
            <> </>
            <WebUniversal {...extendProps} ref={ref} />
            {modalSendMessageVisible
                ? (<SendMessage
                    onClose={() => setModalSendMessageVisible(false)}
                    data={modalSendMessageData} />)
                : null}
        </>
    )
}

export default SmsService;